export default {
  name: 'SymptomDetail',
  data () {
    return {
      departments: [],
      parent:'',
      source: ''
    }
  },
  computed:{
    template(){
      return this.$route.meta.template;
    }
  },
  methods:{
    initPage() {
      this.departments = JSON.parse(localStorage.getItem("departments"));
      this.parent = localStorage.getItem("parent");
    },
    showDepartment(departmentInfo) {
      let orgUid = this.$route.params.orgUid;
      this.$router.push({
        path: `/${this.template}/department/${orgUid}`,
        query:{department:departmentInfo.department, source: this.source, address: departmentInfo.address}
      });
    }
  },
  mounted: function () {
    this.source = this.$route.query.source
    this.initPage();
  }
}



// WEBPACK FOOTER //
// ./src/views/mixins/guide/SymptomDetailMixin.js